export function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    /*                    */
    return result === 0 ? 0 : result;
  };
}
